function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import * as React from 'react';
import * as Formik from 'formik';
import { Field as FieldComponent } from './Field';

var Field = function Field(props) {
  var forceError = props.forceError,
      restProps = _objectWithoutProperties(props, ["forceError"]);

  return React.createElement(Formik.Field, {
    name: props.name
  }, function (_ref) {
    var field = _ref.field,
        form = _ref.form;
    var hasError = (restProps.forceError || form.touched[field.name]) && form.errors[field.name];
    return React.createElement(FieldComponent, _extends({}, field, form, restProps, {
      hasError: hasError ? true : false,
      errorMessage: form.errors[field.name]
    }));
  });
};

export default Field;